module.exports = __webpack_public_path__ + "static/media/icon_Survey2_W.870475a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_Survey2_W.svg
// module id = 1940
// module chunks = 0